import Loader from '../Loader';
import { BoxProps } from '@mui/material';
import { Cell, Price, Root, Unit } from './PriceCellStyle';

interface PriceCellProps extends BoxProps {
  amount: number | undefined;
  unit?: string;
  isLoading: boolean;
  showDecimal?: boolean;
}

function PriceCell({ amount, unit, isLoading, showDecimal, ...rest }: PriceCellProps) {

  const getParsedAmount = (amount: number | undefined) => {
    if (amount !== null && amount !== undefined) {
      let parsedValue: number | null = null;
      if (typeof amount === 'string') {
        parsedValue = parseFloat(amount);
      } else if (typeof amount === 'number') {
        parsedValue = amount;
      }
      if (parsedValue !== null && !isNaN(parsedValue)) {
        const parsedAmount = Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: 'USD',
          minimumFractionDigits: showDecimal ? 2 : 0,
          maximumFractionDigits: showDecimal ? 2 : 0,
        }).format(parsedValue);
        return parsedAmount;
      }
    } else {
      return null;
    }
  };

  return (
    <Root {...rest}>
      <Cell>
        {isLoading ? (
          <Loader />
        ) : (
          <Price className='price-cell-typography'>{getParsedAmount(amount) ?? '$-'}</Price>
        )}
      </Cell>
      {unit && (
        <Unit className='price-cell-typography'>
          {' / '}
          {unit}
        </Unit>
      )}
    </Root>
  );
}

export default PriceCell;
